export default {
  en: {
    editTransferRemark: 'Edit Transfer Remark',
    transferList: 'Transfer',
    edit: 'Save Changes',
    cancel: 'Cancel',
    editTransferRemarkSuccessTitle: 'Success',
    editTransferRemarkSuccessMessage: 'Update Transfer Remark Success.'
  },
  th: {
    editTransferRemark: 'แก้ไขหมายเหตุรถรับส่ง',
    transferList: 'รายการรถรับส่ง',
    edit: 'บันทึก',
    cancel: 'ยกเลิก',
    editTransferRemarkSuccessTitle: 'สำเร็จ',
    editTransferRemarkSuccessMessage: 'แก้ไขหมายเหตุรถรับส่งสำเร็จ'
  }
}
